import { render, staticRenderFns } from "./PolizaSalud.vue?vue&type=template&id=170782c2&scoped=true&"
import script from "./PolizaSalud.vue?vue&type=script&lang=js&"
export * from "./PolizaSalud.vue?vue&type=script&lang=js&"
import style0 from "./PolizaSalud.vue?vue&type=style&index=0&id=170782c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170782c2",
  null
  
)

export default component.exports